import {Injectable} from '@angular/core';
import {KluhManagerValidator} from '../../../../validators/kluh-manager-validator';
import {BaseMonitoringDao} from '../../../../base-monitoring-dao';
import {ProcessorUsage} from '../../../../models-monitoring';
import {R2CloudHttpMonitoringService} from '../../../../r2-cloud-http-monitoring.service';

@Injectable({
    providedIn: 'root'
})
export class ProcessorUsageDaoService extends BaseMonitoringDao<ProcessorUsage> {
    constructor(http: R2CloudHttpMonitoringService, validatorDAO: KluhManagerValidator) {
        super(http, validatorDAO, 'processor-usage');
    }
}
